import { useEffect, useState } from "react";
import Aside from "../../components/Aside"
import CustomDataTable from "../../components/CustomDataTable"
import Footer from "../../components/Footer"
import Header from "../../components/Header"
import { AccountService } from "../../services/AccountsService";
import Swal from 'sweetalert2'
// import { useNavigate } from "react-router-dom";
import { BotService } from "../../services/BotService";
import useTokenApi from "../../hooks/useTokenApi";
import { BOT_STATUS } from "../../constants";
import { useTranslation } from "react-i18next";
import useRequest from "../../hooks/useRequest";
function BotAccountsPage() {
    const { t } = useTranslation();
    const {call, isRequesting} = useRequest();
    const columns = [
        {
            name: t("platform.chatbot.id-account"),
            sortable: true,
            selector: row => row.account_id,
        },
        {
            name: t("platform.chatbot.account"),
            sortable: true,
            selector: row => row.name,
        },
        {
            name: t("platform.chatbot.version"),
            sortable: true,
            center: true,
            selector: row => row.status === BOT_STATUS.NOT_SHOW ? <><span className="legend-indicator bg-danger"></span> {t("platform.chatbot.no-config")}</>: row.bot_version_production,
        },
        {
            name: t("platform.chatbot.status"),
            sortable: true,
            center: true,
            cell: (row) => {
                switch (row.status) {
                    case BOT_STATUS.INACTIVE:
                        return (<><span className="legend-indicator bg-danger"></span> {t("platform.chatbot.inactive")}</>)
                    case BOT_STATUS.ACTIVE:
                        return (<><span className="legend-indicator bg-info"></span> {t("platform.chatbot.active")}</>)
                    case BOT_STATUS.NOT_SHOW:
                        return (<><span className="legend-indicator bg-danger"></span> {t("platform.chatbot.no-config")}</>)
                
                    default:
                        return (<><span className="legend-indicator bg-danger"></span> {t("platform.chatbot.no-config")}</>)
                }
            }
        },
        {
            name: t("platform.chatbot.version-development"),
            sortable: true,
            center: true,
            selector: row => row.status === BOT_STATUS.NOT_SHOW ? <><span className="legend-indicator bg-danger"></span> {t("platform.chatbot.no-config")}</>: row.version,
        },
        {
            name: t("platform.chatbot.actions"),
            sortable: false,
            center: true,
            cell: (row) => {
                return (
                    <>
                        {
                            row.status === 'not_show' && (
                                <button className="btn bg-soft-info-alternative btn-sm" onClick={() => registerBot(row.account_id)}>
                                    {t("platform.chatbot.enable")}
                                </button>
                            )
                        }

                        {  ( row.status === BOT_STATUS.INACTIVE || row.status === BOT_STATUS.ACTIVE) &&
                            <div className="btn-group" role="group">
                                {/* <button className="btn bg-soft-info-alternative text-white-dark btn-sm" onClick={() => navigate(`/bot/builder`, { state: { account_id: row.account_id} })}>
                                    <i className="bi-eye-fill text-primary me-1"></i> {t("platform.chatbot.see")}
                                </button> */}
                                <div className="btn-group">
                                    <button type="button" className="btn bg-soft-info-alternative btn-icon btn-sm dropdown-toggle dropdown-toggle-empty"  data-bs-toggle="dropdown" aria-expanded="false"></button>
        
                                    <div className="dropdown-menu dropdown-menu-end mt-1" >
                                        {
                                            row.status === BOT_STATUS.INACTIVE && <button className="dropdown-item" onClick={() => chanceStatus(row)}><i className="bi bi-shuffle me-3"></i>{t("platform.chatbot.enable")} </button>
                                        }
                                        {
                                            row.status === BOT_STATUS.ACTIVE && <button className="dropdown-item" onClick={() => chanceStatus(row)}><i className="bi bi-shuffle me-3"></i>{t("platform.chatbot.disable")} </button>
                                        }
                                        { row.version !== '3.0' && (
                                            <button className="dropdown-item" onClick={() => updagradaBot(row.account_id)}>
                                                <i className="bi bi-box-arrow-in-up me-3"></i> {t("platform.chatbot.update")}
                                            </button>
                                        )}
                                        
                                    </div>
                                </div>
        
                            </div>
                        }
                    </>
                    
                )
            }
        },
    ];

    // const navigate = useNavigate();
    const { tokenApi } = useTokenApi();
    const [rows, setRows] = useState([])
    const [accountsSelected, setAccountsSelected] = useState([])

    const chanceStatus = async(account: any) => {
        const { isConfirmed } = await Swal.fire({
            title: account.status === BOT_STATUS.ACTIVE ? 'Desactivar chatbot': 'Activar chatbot',
            text: `¿Estás seguro de querer ${account.status === BOT_STATUS.ACTIVE ? 'desactivar': 'activar'} este chatbot?`,
            icon: 'warning',
            iconColor: '#f5ca99',
            confirmButtonText: 'Continuar',
            cancelButtonText: 'Cancelar',
            customClass: {
                cancelButton: 'btn btn-white',
                confirmButton: 'btn btn-primary me-3',
            },
            buttonsStyling: false,
            showConfirmButton: true,
            focusDeny: true,
            focusCancel: true,
            showCancelButton: true,
            showLoaderOnConfirm: true,
            preConfirm: async () => {
                await BotService.setStatus({
                    token: tokenApi,
                    bot_id: account.bot_id,
                    status: account.status === BOT_STATUS.ACTIVE ? BOT_STATUS.INACTIVE: BOT_STATUS.ACTIVE
                })
    
                await getAccounts();
            }
        })

        if(isConfirmed) {
            Swal.fire('¡Éxito!', 'Se cambio el estatus correctamente', 'success')
        }
    }

    const updagradaBot = async(account_id: number) => {
        const { isConfirmed } = await Swal.fire({
            title: 'Actualizar versión',
            text: '¿Estás seguro de querer actualizar a la última versión disponible? Está acción no se puede deshacer',
            icon: 'warning',
            iconColor: '#f5ca99',
            confirmButtonText: 'Continuar',
            cancelButtonText: 'Cancelar',
            customClass: {
                cancelButton: 'btn btn-white order-1  me-3',
                confirmButton: 'btn btn-primary order-2',
            },
            buttonsStyling: false,
            showConfirmButton: true,
            focusDeny: true,
            focusCancel: true,
            showCancelButton: true,
            showLoaderOnConfirm: true,
            preConfirm: async () => {
                await BotService.register({
                    token: tokenApi,
                    account_id: account_id,
                    subaccount_id: null
                })
    
                await getAccounts();
            }
        })

        if(isConfirmed) {
            Swal.fire('¡Éxito!', 'Se actualizó correctamente el chatbot', 'success')
        }
    }


    const registerBot = async(account_id: number) => {
        const { isConfirmed } = await Swal.fire({
            title: 'Activar chatbot',
            text: '¿Estás seguro de querer activar la opción de chatbot para esta cuenta?',
            icon: 'warning',
            iconColor: '#f5ca99',
            confirmButtonText: 'Continuar',
            cancelButtonText: 'Cancelar',
            customClass: {
                cancelButton: 'btn btn-white order-1  me-3',
                confirmButton: 'btn btn-primary order-2',
            },
            buttonsStyling: false,
            showConfirmButton: true,
            focusDeny: true,
            focusCancel: true,
            showCancelButton: true,
            showLoaderOnConfirm: true,
            preConfirm: async () => {
                await BotService.register({
                    token: tokenApi,
                    account_id: account_id,
                    subaccount_id: null
                })
    
                await getAccounts();
            }
        })

        if(isConfirmed) {
            Swal.fire('¡Éxito!', 'Se activo correctamente el chatbot', 'success')
        }
    }

    const getAccounts = async() => {
        const { data } = await call(AccountService.getBotAccounts);
        setRows(data)
    }

    useEffect(() => {
        getAccounts();
    }, [])
    

    return (
        <>
            <Header />
            <Aside />

            <main id="content" role="main" className="main">

                <div className="content container-fluid" >

                    <div className="page-header">
                        <div className="row align-items-center">
                            <div className="col-sm mb-2 mb-sm-0">
                                <nav aria-label="breadcrumb">
                                    <ol className="breadcrumb breadcrumb-no-gutter">
                                        <li className="breadcrumb-item "><span className="breadcrumb-link" >{t("platform.platform-title")}</span></li>
                                        <li className="breadcrumb-item "><span className="breadcrumb-link" >{t("platform.chatbot.chatbot-title")}</span></li>
                                        <li className="breadcrumb-item active" aria-current="page">{t("platform.chatbot.accounts-title")}</li>
                                    </ol>
                                </nav>
                                <h1 className="page-header-title text-white-dark"><i className="bi-person-rolodex text-primary nav-icon"></i> {t("platform.chatbot.accounts-title")}</h1>
                            </div>
                           
                        </div>

                    </div>

                    <div className="row">
                        <div className="col-sm-12">
                            <CustomDataTable
                                showExport={false}
                                columns={columns}
                                isLoading={isRequesting}
                                data={rows.filter( row => accountsSelected && accountsSelected.length ? accountsSelected.find( a => a.label === row.name ): true)}
                                filter={(row, term) => {
                                    if(!term) return true;

                                    return (
                                        `${row.name}`.match(new RegExp(`${term}`, 'i')) 
                                    )
                                }}
                                onAccountsSelected={ (accounts) => setAccountsSelected(accounts) }
                            />
                        </div>

                    </div>

                </div>

                <Footer />
            </main>
        </>
    )
}
export default BotAccountsPage